// extracted by mini-css-extract-plugin
export default {"appContainer":"AppLayout_appContainer__QaNo4","main":"AppLayout_main__RESz3"};